// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SectionIndex = function (x) {
    return x;
};
var tsBridgeSectionIndex = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedNumberType("SectionIndex")("__brandSectionIndex"));
    }
};
var writeSectionIndex = Simple_JSON.writeForeignNumber;
var unwrap = function (v) {
    return v;
};
var showSectionIndex = Data_Show.showNumber;
var readSectionIndex = Simple_JSON.readNumber;
var ordSectionIndex = Data_Ord.ordNumber;
var newtypeSectionIndex = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSectionIndex = SectionIndex;
var eqSectionIndex = Data_Eq.eqNumber;
export {
    SectionIndex,
    makeSectionIndex,
    unwrap,
    newtypeSectionIndex,
    eqSectionIndex,
    ordSectionIndex,
    showSectionIndex,
    readSectionIndex,
    writeSectionIndex,
    tsBridgeSectionIndex
};
//# sourceMappingURL=index.js.map
